/**
 * @module store/users/actions
 *
 * @version 1.0.1
 * @copyright SBC 2019
 */


import { Auth } from 'aws-amplify';


import { apiGetUsers, apiDeleteUsers } from '@/api';
import * as types from '@/store/mutation-types';

/**
 * Action: Sign up of user
 *
 * @since Version 1.0.0
 */
const getUsers = async ({ commit, rootGetters }, { limit, offset }) => {
  commit(types.GET_USERS_ASYNC.PENDING);
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      const { data, total } = await apiGetUsers(userSession.accessToken.jwtToken, { limit, offset });

      commit(types.GET_USERS_ASYNC.SUCCESS, {
        data,
        total,
      });
    } else {
      throw new Error('Неавторизованный пользователь не может получить список e-mail.');
    }
  } catch (error) {
    console.log(error);
    commit(types.GET_USERS_ASYNC.FAILURE);
  }
};


/**
 * Action: Delete emails
 *
 * @since Version 1.0.1
 */
const deleteUsers = async ({ rootGetters }, currentUser) => {
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      await apiDeleteUsers(userSession.accessToken.jwtToken, currentUser);
    } else {
      throw new Error('Неавторизованный пользователь не может получить список ордеров.');
    }
  } catch (error) {
    console.log(error);
  }
};

export default {
  deleteUsers,
  getUsers,
};
